export default [

     {
          path: '/task-details/:id',
          name: 'TaskDetails',
          component: () => import("@/views/Page/StrategicPlan/Task/TaskDetails.vue"),
           meta: {
               title: 'TaskDetails',
          },
     }
];